<template>
    <el-tabs id="ranking-tabs" v-model="active" @tab-click="onChange">
        <el-tab-pane label="Trưởng phòng" name="0"/>
        <el-tab-pane label="Trưởng bộ phận" name="1"/>
        <el-tab-pane label="Trưởng nhóm" name="2"/>
        <el-tab-pane label="Nhân viên" name="3"/>
    </el-tabs>
</template>

<script>
export default {
    props: {
        tab: {
            type: String,
            required: true,
            default: '0'
        }
    },
    data() {
        return { active: this.tab }
    },
    methods: {
        onChange(tab) {
            this.$emit('changeTab', tab.name)
        }
    },
    watch: {
        category(newVal) {
            this.active = newVal
        }
    }
}
</script>

<style>
#ranking-tabs .el-tabs__nav-wrap::after {
    display: none !important;
}
#ranking-tabs .el-tabs__active-bar {
    display: none !important;
}

#ranking-tabs .is-active {
    background: #503694 !important;
}

#ranking-tabs .el-tabs__item {
    background: #AFA4F7;
    border-radius: 20px;
    color: #fff;
    margin-right: 8px;
    padding: 0 60px !important;
    font-weight: 500;
    transition: all 0.3s;
}
#ranking-tabs .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
}
</style>
